import { useState } from 'react';
import { User } from '../types/user';
import ServicesTab from './UserTabs/ServicesTab';
import DevicesTab from './UserTabs/DevicesTab';
import SubscriptionsTab from './UserTabs/SubscriptionsTab';
import PaymentsTab from './UserTabs/PaymentsTab';
import { useUserServices } from '../hooks/useUserService';
import AdministratorTab from './UserTabs/AdministratorTab';

interface UserProfileBodyProps {
  user: User;
}

// Tab components
const ActivityTab = () => <div className='text-white'>User activity</div>;

const tabs = (user: User) => [
  { id: 'services', label: 'Registered Services', component: () => <ServicesTab user={user} /> },
  { id: 'devices', label: 'Devices', component: () => <DevicesTab user={user} /> },
  { id: 'subscriptions', label: 'Subscriptions', component: () => <SubscriptionsTab user={user} /> },
  { id: 'payments', label: 'Payments', component: () => <PaymentsTab user={user} /> },
  { id: 'actions', label: 'Administrative Actions', component: () => <AdministratorTab user={user} /> },
  { id: 'activity', label: 'Activity', component: () => <ActivityTab /> },
];
export default function UserProfileBody({ user }: UserProfileBodyProps) {
  const [activeTab, setActiveTab] = useState('services');
  const ActiveComponent = tabs(user).find(tab => tab.id === activeTab)?.component || (() => null);

  console.log("Selected User", user);

  return (
    <div className="w-full flex flex-col items-start justify-start my-6">
      {/* Tab Navigation */}
      <div className="flex border-b border-gray-700 w-full">
        {tabs(user).map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-6 py-3 text-sm font-medium ${
              activeTab === tab.id
                ? 'text-white border-b-2 border-white'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Active Tab Content */}
      <div className="w-full mt-4">
        <ActiveComponent />
      </div>
    </div>
  );
}